export default __webpack_public_path__ + "static/request-accepted-caf80c17e2ca35b40cfebebdf0d05b2c.png";